import { PillBadge } from '@platform/components';

const StackedPillsList = ({ items }: { items: string[] }) => {
  return (
    <div className='flex flex-col gap-2'>
      {items.map((item) => (
        <span key={`pill-container-${item}`}>
          <PillBadge key={`pill-${item}`} variant='plain' color='blue' size='md'>
            {item}
          </PillBadge>
        </span>
      ))}
    </div>
  );
};

const Title = ({ children }: { children: React.ReactNode }) => {
  return <div className='mb-2 text-sm font-medium text-gray-500'>{children}</div>;
};

export const OrgPillsPanel = ({
  sustainabilityGoals,
  industries,
}: {
  sustainabilityGoals: string[];
  industries: string[];
}) => {
  return (
    <div className='h-fit border border-gray-100 px-4 py-5 flex flex-col gap-6 rounded-xl'>
      <div>
        <Title>Impact Goals</Title>
        <StackedPillsList items={sustainabilityGoals} />
      </div>
      <div>
        <Title>Main industries</Title>
        <StackedPillsList items={industries} />
      </div>
    </div>
  );
};
